import urls from "../../api/urls.json";
import { authorizedHttpGet, authorizedHttpPost } from "../../api/httpCalls";
import { useState, useRef, useEffect } from "react";
import Loader from "../Loader";
import { FlexWrapper, GapView } from '../../styles/WrapperStyles'
import { BaseButton, BottomButton } from '../../styles/ButtonStyles';
import styled, { css } from 'styled-components';
import ReportModal from "../modals/ReportModal";
import SortByModal from "../modals/SortByModal";
import previous_inctive from '../../assests/arrow_back_grey.png';
import next_inactive from '../../assests/arrow_forward_grey.png';
import previous_active from '../../assests/arrow_back.png';
import next_active from '../../assests/arrow_forward.png';
import PageModal from "../modals/PageModal";
import placeholder_image from "../../assests/placeholder_image.png"
import {
    CommonTextStyleSpan,
} from '../../styles/TextStyles';
import { ImageDivFeed, ImageCirlceView } from '../../styles/ImageWrapper';
import ActivityModal from "../modals/ActivityModal";
import LeftNav from "../LeftNav";
import { useLocation, useNavigate } from "react-router-dom";
import EmptyView from '../EmptyView'
import VerifyModal from "../modals/VerifyModal";

const BottomBarWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    margin-top: 50px;
    margin-bottom: 50px;
`;


const ProfileItemWrapper = styled(FlexWrapper)`
  margin-top: 15px;
`;

const BanButton = styled(BaseButton)`
  margin-left: 20px;
  width: 110px;
  height: 55px;
  margin-top: 50px;
  margin-left: 20px;
  background-color: #ffffff;
  border-color: black;
  color: black;
  margin-top: 20px;
`;


const NameWrapper = styled.div`
  margin-left: 20px;
  ${props =>
        props.width &&
        css`
      width: ${props.width};
      max-width: ${props.maxwidth};
    `}
`;


const NameSpan = styled.span`
  color: #9b9b9b;
  ${props =>
        props.selected &&
        css`
      color: blue;
      cursor: pointer;
    `}
`;

const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `};
`;

const HeaderWrapper = styled(FlexWrapper)`
    // display: inline;

    height: 55px;  
    padding: 0 30px 0 30px;
    border-radius: 27.5px;
    background-color: #f8f8fa;
    align-items:center;
    ${props => props.width && css`
        width:${props.width}
    `}
`;

const HeaderTextView = styled.span`
    font-family:'Gilory-Semi';
    font-size: 20px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #d7d7d7;
    ${props =>
        props.marginRight &&
        css`
        margin-right: 10px;
      `}
    ${props =>
        props.selected &&
        css`
        color: #767676;
        font-family: 'Gilory-Bold';
      `}
    ${props =>
        props.cursor &&
        css`
        cursor: pointer;
      `}
`;

const SelectedView = styled.button`
  width: 55px;
  height: 55px;
  border-radius: 27.5px;
  border: solid 5px #484848;
  color: #ffffff;
  background-color: #ffffff;
  margin-top: 20px;
  font-size: 20px;
  ${props =>
        props.selected &&
        css`
      background-color: #484848;
    `}
`;

function Reports() {
    const location = useLocation();
    const navigate = useNavigate();
    const authToken = localStorage.getItem('authToken');
    const isOtpVerified = localStorage.getItem('verificationPassed');
    if (!authToken || !isOtpVerified) {
        sessionStorage.setItem('redirectUrl', location.pathname)
        navigate('/login')
    }
    const [appName, setAppName] = useState(localStorage.getItem('appName'))
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [reportOptions, setReportOptions] = useState([]);
    const [displayReportOptions, setDisplayReportOptions] = useState(false);
    const [displaySortByOptions, setDisplaySortByOptions] = useState(false);
    const [displayActivityModal, setDisplayActivityModal] = useState(false);
    const [reportOption, setReportOption] = useState("All");
    const [sortByOption, setSortByOption] = useState("most_reported");
    const reasonId = useRef(0);
    const totalPages = useRef(1);
    const [profiles, setProfiles] = useState([]);
    const [activityFilter, setActivityFilter] = useState({});
    const [displayPageModal, setDisplayPageModal] = useState(false);
    const [currentTab, setCurrentTab] = useState("Reported");
    const totalProfiles = useRef(0);
    const [decoy, setDecoy] = useState(false);
    const [displaySelfieModal, setDisplaySelfieModal] = useState(false);
    const [selfieUrl, setSelfieUrl] = useState('');

    const toggleActivityModal = (filter, title, ref) => {
        setActivityFilter({ filter: filter, title: title, userRef: ref })
        setDisplayActivityModal(true)
    }

    const handleLeftNavAppChange = (name) => {
        setAppName(name)
        setPage(1)
    };

    const fetchReports = async () => {
        setProfiles([]);
        setIsLoading(true);
        let state = {
            "Reported": "pending",
            "Checked": "checked",
            "Address": "addressed"
        }
        let params = { "page": page, "sort_by": sortByOption, "state": state[currentTab] };
        if (reasonId.current !== 0) {
            params.reason_id = reasonId.current;
        }
        let response = await authorizedHttpGet(urls.GET_REPORTED, params);
        if (response.status) {
            setReportOptions(response.data.report_options);
            setProfiles(response.data.reported_users)
            totalPages.current = response.data.total_pages;
            totalProfiles.current = response.data.total_profiles;
        }
        setIsLoading(false);
    }

    useEffect(() => {
        fetchReports();
    }, [page, appName, reasonId.current, sortByOption, currentTab]);

    const updateOption = (option) => {
        reasonId.current = option.id;
        setReportOption(option.name);
        setDisplayReportOptions(false);
    }

    const updateSortByOption = (option) => {
        setSortByOption(option);
        setDisplaySortByOptions(false);
    }

    const sortDefault = {
        "most_reported": "Most Reported",
        "most_recently": "Most Recently"
    }

    const banUser = async (profileRef) => {
        setIsLoading(true);
        await authorizedHttpPost(urls.BAN_PROFILE, { "ref": profileRef })
        setIsLoading(false);
        fetchReports();
    }

    const handlePageChange = (direction) => {
        if (direction === 'next') {
            if (parseInt(page) < totalPages.current) {
                setPage(parseInt(page) + 1);
            }
        } else {
            if (parseInt(page) > 1) {
                setPage(parseInt(page) - 1);
            }
        }
    }

    const goToPage = (pageModalNumber) => {
        setDisplayPageModal(false);
        if (pageModalNumber > totalPages.current) {
            alert("Page number is greater than total pages");
        } else {
            setPage(pageModalNumber);
        }
    }

    const handleTabChange = (tab) => {
        setCurrentTab(tab);
        setPage(1);
    }

    const closeModal = () => {
        setDisplaySelfieModal(false);
        setSelfieUrl('');
    }

    const saveData = async () => {
        setIsLoading(true);
        var checkedReports = [];
        var addressedReports = [];
        profiles.map((profile) => {
            if (profile.addressed_state) {
                addressedReports.push({ ref: profile.ref, id: profile.id });
            } else {
                checkedReports.push({ ref: profile.ref, id: profile.id });
            }
        })
        var params = {
            checkedReports: checkedReports,
            addressedReports: addressedReports,
            sort_by: sortByOption
        };

        let response = await authorizedHttpPost(urls.POST_REPORTED, params);
        if (response.status) {
            if (response.data.status) {
                await fetchReports();
            }
        }
        setIsLoading(false);
    }

    return (
        <div className="App">
            <LeftNav handleLeftNavAppChange={handleLeftNavAppChange} tabName={'Reports'} />
            <div className="marginLeft200">
                {isLoading && <Loader />}
                {displaySelfieModal && selfieUrl && <VerifyModal closeModal={closeModal} image={selfieUrl} hide_buttons={true} />}
                {displayActivityModal && <ActivityModal closeModal={() => setDisplayActivityModal(false)} filter={activityFilter.filter} title={activityFilter.title} user_ref={activityFilter.userRef} />}
                {displayReportOptions && <ReportModal closeModal={() => setDisplayReportOptions(false)} reportOptions={reportOptions} updateOption={updateOption} />}
                {displaySortByOptions && <SortByModal closeModal={() => setDisplaySortByOptions(false)} updateOption={updateSortByOption} />}
                {displayPageModal && <PageModal goToPage={goToPage} page={page} closeModal={() => setDisplayPageModal(false)} />}
                <FlexWrapper className="marginTop25">
                    <HeaderWrapper className="cursorPointer" onClick={() => setDisplayPageModal(true)}>
                        <HeaderSelected>{page}</HeaderSelected>
                        <HeaderSelected className="marginLeft10">{totalPages.current}</HeaderSelected>
                        <HeaderSelected className="marginLeft10">{totalProfiles.current}</HeaderSelected>
                    </HeaderWrapper>
                    <HeaderWrapper className="marginLeft50 cursorPointer">
                        <HeaderTextView marginRight selected={currentTab === 'Reported' ? true : false} onClick={() => handleTabChange('Reported')}>Reported</HeaderTextView>
                        <HeaderTextView marginRight selected={currentTab === 'Checked' ? true : false} onClick={() => handleTabChange('Checked')}>Checked</HeaderTextView>
                        <HeaderTextView marginRight selected={currentTab === 'Address' ? true : false} onClick={() => handleTabChange('Address')}>Address</HeaderTextView>
                    </HeaderWrapper>
                    <HeaderWrapper className="marginLeft50 cursorPointer" onClick={() => setDisplayReportOptions(true)}>
                        <HeaderSelected>{reportOption}</HeaderSelected>
                    </HeaderWrapper>
                    <HeaderWrapper className="marginLeft50" onClick={() => setDisplaySortByOptions(true)}>
                        <HeaderSelected>{sortDefault[sortByOption]}</HeaderSelected>
                    </HeaderWrapper>
                </FlexWrapper>
                {
                    profiles.map((profile, pos) => {
                        return (
                            <ProfileItemWrapper key={profile.ref}>
                                <ImageDivFeed
                                    key={profile.avatar}
                                    src={profile.avatar}
                                    onError={e => {
                                        e.target.src = placeholder_image;
                                    }}
                                />
                                <NameWrapper width="320px">
                                    <CommonTextStyleSpan highlight>
                                        <NameSpan
                                            selected={profile.selfie_url}
                                            onClick={() => {
                                                setSelfieUrl(profile.selfie_url);
                                                setDisplaySelfieModal(true);
                                            }}
                                        >
                                            {profile.name}
                                        </NameSpan>
                                        , {profile.gender[0]}, {profile.age}
                                    </CommonTextStyleSpan>
                                    <CommonTextStyleSpan> {profile.ref}</CommonTextStyleSpan>
                                    {profile.location_str && (
                                        <>
                                            <br />
                                            <CommonTextStyleSpan>{profile.location_str}</CommonTextStyleSpan>
                                        </>
                                    )}
                                    <br />
                                    <br />
                                    <br />
                                    <CommonTextStyleSpan>
                                        {profile.reporting_date} / {profile.reporting_time}  
                                        <br />
                                        {profile.is_deleted ? `deleted-${profile.status}` : profile.status}
                                        <br />
                                        Deleted: {profile.is_deleted ? 'Yes' : 'No'}
                                        <br/>
                                        Blocked by: {profile.reporter_profile_name}
                                        <br />
                                        Blocked by ref: {profile.reporter_profile_ref}
                                    </CommonTextStyleSpan>
                                    <br />
                                    <CommonTextStyleSpan
                                        show_cursor
                                        onClick={() => {
                                            toggleActivityModal('blocked_by', 'Blocked By', profile.ref)
                                        }}
                                    >
                                        Block Count: {profile.block_count}
                                    </CommonTextStyleSpan>
                                    <br />
                                    <CommonTextStyleSpan>
                                        Report Count: {profile.report_count}
                                    </CommonTextStyleSpan>
                                </NameWrapper>
                                <NameWrapper width="max-content" maxwidth="250px">
                                    <CommonTextStyleSpan grey>{profile.reason}</CommonTextStyleSpan>
                                    <br />
                                    <br />
                                    <br />
                                    <CommonTextStyleSpan grey>
                                        {profile.message}
                                    </CommonTextStyleSpan>
                                </NameWrapper>
                                <GapView width="20px" />
                                <ImageCirlceView
                                    src={profile.reporter_profile_avatar}
                                    onError={e => {
                                        e.target.src = placeholder_image;
                                    }}
                                />
                                <BanButton onClick={() => banUser(profile.ref)}>
                                    BAN
                                </BanButton>
                                {
                                    currentTab === 'Reported' &&
                                    <FlexWrapper>
                                        <GapView width="50px" />
                                        <SelectedView
                                            onClick={() => {
                                                setDecoy(!decoy);
                                                var list = profiles;
                                                list[pos].addressed_state = list[pos].addressed_state
                                                    ? false
                                                    : true;
                                                setProfiles(list);
                                            }}
                                            selected={profile.addressed_state}
                                        >
                                            {profile.addressed_state ? 'X' : ''}
                                        </SelectedView>
                                    </FlexWrapper>
                                }
                            </ProfileItemWrapper>
                        );
                    })
                }
                {
                    profiles.length > 0 &&
                    <BottomBarWrapper>
                        {parseInt(page) === 1 ? <img src={previous_inctive} className="cursorPointer" /> : <img src={previous_active} onClick={() => handlePageChange('previous')} className="cursorPointer" />}
                        {parseInt(page) === totalPages.current ? <img className="cursorPointer marginLeft30" src={next_inactive} onClick={() => handlePageChange('next')} /> : <img className="cursorPointer marginLeft30" src={next_active} onClick={() => handlePageChange('next')} />}
                        {currentTab === 'Reported' && <BaseButton onClick={() => saveData()}>Save</BaseButton>}
                    </BottomBarWrapper>
                }
                {
                    profiles.length === 0 && <EmptyView />
                }
            </div>
        </div>
    );
}

export default Reports;
